/**
 * 通过账号权限过滤路由配置
 */
export function routeFilter(routeConfigArray, userPermissionArray) {
  const match = [];
  routeConfigArray.forEach((routeConfig) => {
    const item = { ...routeConfig };
    if (item.children) {
      item.children = routeFilter(routeConfig.children, userPermissionArray);
    }
    if (routeConfig.meta
      && routeConfig.meta.permissions
      && routeConfig.meta.permissions.length > 0) {
      const allow = userPermissionArray.some(permission => (
        routeConfig.meta.permissions.indexOf(permission) >= 0
      ));
      if (allow) {
        match.push(item);
      }
    } else {
      match.push(item);
    }
  });
  return match;
}

/**
 * 通过账号权限过滤菜单项
 */
export function menuFilter(menuConfig, userPermissionArray) {
  return routeFilter(menuConfig, userPermissionArray);
}

// eslint-disable-next-line no-unused-vars
let initIndex = 0;

export function gui(tree, projects, index) {
  // eslint-disable-next-line no-param-reassign
  index += 1;
  if (index > initIndex) {
    initIndex = index;
  }
  tree.forEach((g) => {
    g.laye = index;
    const item = g.project;
    const arr = projects.filter(e => e.project.fatherId === item.id).sort(e => e.project.id);
    g.entity = {
      name: g.name,
      type: g.type,
      path: g.path,
      icon: g.icon,
      isI18n: g.isI18n,
      project: g.project,
    };
    if (arr.length > 0) {
      g.children = gui(arr, projects, index);
    }
  });
  return tree;
}

export function listToMenuList(configs, corporationName) {
  configs.forEach((m) => {
    if (m.name === 'projects') {
      const projects = m.children;
      const tree = [];
      const base = {
        project: {
          id: 0,
          name: corporationName,
        },
      };
      tree.push(base);
      initIndex = 0;
      const gui1 = gui(tree, projects, 0);
      console.log(initIndex);
      m.children = gui1[0].children;
      m.maxIndex = initIndex;
      m.isI18n = false;
      m.icon = 'projects';
    } else if (m.children) {
      m.children.forEach((g) => {
        g.entity = {
          icon: g.icon,
          name: g.name,
          path: g.path,
          isI18n: g.isI18n,
          super: g.super,
          meta: g.meta,
        };
      });
    }
    m.entity = {
      icon: m.icon,
      name: m.name,
      path: m.path,
      isI18n: m.isI18n,
      super: m.super,
      dfOpen: m.dfOpen ? m.dfOpen : false,
      meta: m.meta,
    };
  });
  return configs;
}

/**
 * 账号权限判断
 * @param {string} permission 声明需要的权限
 * @return {boolean}
 */
export function hasPermission(permission) {
  const userPermissionArray = sessionStorage.permissions || [];
  return userPermissionArray.indexOf(permission) >= 0;
}
